export const lazyLoadingArg = {
  lazyLoading: {
    defaultValue: true,
    control: { type: 'boolean' },
    table: { category: 'Media' }
  }
};

export const initAllLazyVideos = (): void => {
  const videos = document.querySelectorAll<HTMLVideoElement | HTMLIFrameElement>(
    'video[data-lazyload=true], iframe[data-lazyload=true]'
  );

  const setVideoSource = (video: HTMLVideoElement | HTMLSourceElement | HTMLIFrameElement): void => {
    if (video.dataset.src) {
      video.src = video.dataset.src as string;
    }
  };

  videos.forEach((video) => {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (video.dataset.src) {
            setVideoSource(video);
          } else {
            video.querySelectorAll('source').forEach(setVideoSource);
          }

          if (video.tagName === 'VIDEO') {
            (video as HTMLVideoElement).load();
          }

          videoObserver.unobserve(video);
        }
      });
    });

    videoObserver.observe(video);
  });
};
